import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import './GenericField.css';
import spinner from '../../../../static/spinner.gif';

const GenericField = data => {
  const [show, setShow] = useState(false);

  const flipState = () => {
    setShow(!show);
  };

  if (!data?.data && !data.error && !data?.isLoading) {
    return null;
  }

  if (!data?.data && !data.error && data?.isLoading) {
    return (
      <Container className="mb-1">
        <h5>
          <b>{data.title}</b>
        </h5>
        <img src={spinner} alt="Loading..." className="App-spinner" />
      </Container>
    );
  }

  return data.error ? (
    <Container className="mb-1">
      <h5>
        <b>{data.title}</b>
      </h5>
      {data.isTreatErrorAsInfo ? (
        <b className="color-dark-yellow">{data.error}</b>
      ) : (
        <b className="color-red">{data.error}</b>
      )}
    </Container>
  ) : (
    <Container>
      <h5 className="cursor-pointer" onClick={flipState}>
        <b>{data.title + (show ? ' (Hide) ' : '( Show )')}</b>
      </h5>
      {show && (
        <ol className="bg-gray border-radius-5 mt-0 p-1">
          {data?.data &&
            data?.data?.map((value, index) => {
              return <li key={index}>{value}</li>;
            })}
        </ol>
      )}
    </Container>
  );
};

export default GenericField;
